export const environment = {
    apiUrl: 'https://abn.artist-match.io/api/artistmatch/v1',
    okta: {
        clientId: '0oa4v9aemm5nXJJqd0x7',
        issuer: 'https://login.abn.artist-match.io/oauth2/default',
        redirectUri: window.location.origin + '/login/callback',
        scopes: ['openid', 'profile', 'email'],
        pkce: true,
        tokenManager: {
            storage: 'sessionStorage'
        },
    }
}; 